import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    api
      .googleSession(sessionId)
      .then((user) => {
        setUser(user);
        nav("/library", { replace: true });
      })
      .catch(() => {
        toast.error("Google sign-in failed");
        setUser(false);
        nav("/login", { replace: true });
      });
  }, [nav, setUser]);

  return null;
}
